// src/components/LineChart.jsx

import React, { useEffect, useState } from "react";
import Chart from "chart.js/auto";
import { supabase } from "../Services/supabaseClient";
import { useCompany } from "../context/CompanyContext";

const LineChart = () => {
  const { companyId } = useCompany();
  const [clientInvoiceData, setClientInvoiceData] = useState([]);

  // 1️⃣ Fetch invoice counts by client, for this company
  useEffect(() => {
    if (!companyId) return;

    (async () => {
      const { data, error } = await supabase.rpc(
        "get_client_invoice_counts_by_company",
        { p_company_id: companyId }
      );

      if (error) {
        console.error("Error loading client invoice counts:", error);
      } else {
        // expect rows like { customer_name, invoice_count }
        setClientInvoiceData(
          data.map((row) => ({
            customer: row.customer_name,
            invoiceCount: parseInt(row.invoice_count, 10) || 0,
          }))
        );
      }
    })();
  }, [companyId]);

  // 2️⃣ Render / re-render the line chart
  useEffect(() => {
    if (clientInvoiceData.length === 0) return;

    const canvas = document.getElementById("invoicesChart");
    const existingChart = Chart.getChart(canvas);
    if (existingChart) existingChart.destroy();

    const ctx = canvas.getContext("2d");
    const chart = new Chart(ctx, {
      type: "line",
      data: {
        labels: clientInvoiceData.map((c) => c.customer),
        datasets: [
          {
            label: "Number of Invoices",
            data: clientInvoiceData.map((c) => c.invoiceCount),
            fill: true,
            backgroundColor: "rgba(0, 128, 128, 0.6)",
            borderColor: "rgba(75, 192, 192, 1)",
            borderWidth: 2,
            // Let Chart.js pick default colors
          },
        ],
      },
      options: {
        maintainAspectRatio: true,
        scales: {
          x: {
            title: {
              display: true,
              text: "Clients",
            },
          },
          y: {
            beginAtZero: true,
            title: {
              display: true,
              text: "Invoices",
            },
          },
        },
      },
    });

    return () => chart.destroy();
  }, [clientInvoiceData]);

  return (
    <div style={{ position: "relative", height: "300px" }}>
      <canvas id="invoicesChart" />
    </div>
  );
};

export default LineChart;
